import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import GuidaArticle from "../pages/articolo/guida-completa-itaobuy-spreadsheet/page";
import TutorialArticle from "../pages/articolo/tutorial-itaobuy-spreadsheet/page";
import SicurezzaArticle from "../pages/articolo/sicurezza-itaobuy-spreadsheet/page";
import TemplateArticle from "../pages/articolo/template-itaobuy-spreadsheet/page";
import AlternativeArticle from "../pages/articolo/alternative-itaobuy-spreadsheet/page";
import ComeFunzionaArticle from "../pages/articolo/come-funziona-itaobuy-spreadsheet/page";
import RecensioneArticle from "../pages/articolo/recensione-itaobuy-spreadsheet/page";
import ConfrontoArticle from "../pages/articolo/confronto-itaobuy-spreadsheet/page";
import OpinioniArticle from "../pages/articolo/opinioni-itaobuy-spreadsheet/page";

const routes: RouteObject[] = [
  { path: "/", element: <Home /> },
  { path: "/articolo/guida-completa-itaobuy-spreadsheet", element: <GuidaArticle /> },
  { path: "/articolo/tutorial-itaobuy-spreadsheet", element: <TutorialArticle /> },
  { path: "/articolo/sicurezza-itaobuy-spreadsheet", element: <SicurezzaArticle /> },
  { path: "/articolo/template-itaobuy-spreadsheet", element: <TemplateArticle /> },
  { path: "/articolo/alternative-itaobuy-spreadsheet", element: <AlternativeArticle /> },
  { path: "/articolo/come-funziona-itaobuy-spreadsheet", element: <ComeFunzionaArticle /> },
  { path: "/articolo/recensione-itaobuy-spreadsheet", element: <RecensioneArticle /> },
  { path: "/articolo/confronto-itaobuy-spreadsheet", element: <ConfrontoArticle /> },
  { path: "/articolo/opinioni-itaobuy-spreadsheet", element: <OpinioniArticle /> },
  { path: "*", element: <NotFound /> },
];

export default routes;